/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */


import React from 'react';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import { Button } from 'reactstrap';
import SimpleTooltip from '@components/simple-tooltip';
import variables from '../../../../css/variables.module.scss';
import { AnimatedProgressProvider } from '@components/survey-progress/AnimatedProgressProvider';

interface QuestionProgressProps {
  completed: number | undefined;
  groupName: JSX.Element | string
  colour?: string;
  onClick?: () => void;
  disabled?: boolean;
  logo?: string;
  className?: string;
}

const QuestionProgress = (props: QuestionProgressProps) => {
  const { className, logo, completed, groupName, colour, onClick, disabled } = props;
  const surveyPackStyle = disabled && onClick ? 'survey-pack' : '';
  return <div className={surveyPackStyle}>
    <Button className={`circular-progress-btn mr-1 ${className ?? ''}`} color='transparent' disabled={disabled || !onClick} onClick={disabled ? undefined : onClick}>
      <div className='circular-progress-container'>
        <AnimatedProgressProvider
          valueStart={0}
          valueEnd={completed ?? 0}
          duration={2}
        >
          {(value: number) => {
            const roundedValue = Math.round(value);
            return (
              <CircularProgressbar
                value={value}
                text={logo || completed === undefined ? '' : `${roundedValue}%`}
                strokeWidth={12}
                styles={buildStyles({
                  backgroundColor: '#000',
                  pathColor: colour || variables.yaleBlue,
                  trailColor: variables.lightGrey,
                  textSize: '12px',
                  textColor: colour || variables.ravenGrey,
                  pathTransition: 'none'
                })}
              />
            );
          }}
        </AnimatedProgressProvider>
        {logo ? <div className='logo'><img src={logo} alt={''} /></div> : null}
      </div>
      <SimpleTooltip text={disabled ? <>Survey has been marked as complete.<br />To add additional survey packs please first mark your survey as “In Progress”</> : ''}>
        <p className='text-center text-ThemeTextDark pt-3'>{groupName}</p>
      </SimpleTooltip>
    </Button>
  </div>
}

export default QuestionProgress;
